import { defaultProducts } from './module-products-state';

export default {
	resetState(state) {
		//Object.assign(state, defaultAuthState);
	},
	updateSpecialConsumptionProducst(state, res) {
		state.SpecialConsumptionProducst.removeAll();
		state.SpecialConsumptionProducst.append(res.Data);
	},
	updateEnviromentTaxProducts(state, res) {
		state.EnviromentTaxProducts.removeAll();
		state.EnviromentTaxProducts.append(res.Data);
	},
	updateEnviromentFeesProducts(state, res) {
		state.EnviromentFeesProducts.removeAll();
		state.EnviromentFeesProducts.append(res.Data);
	},
	updateFeesChargesProducts(state, res) {
		state.FeesChargesProducts.removeAll();
		state.FeesChargesProducts.append(res.Data);
	},
	updateTypeWorksProducts(state, res) {
		state.TypeWorks.removeAll();
		state.TypeWorks.append(res.Data);
	}
};
